import React, { useCallback, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Select from "react-select";
import Swal from "sweetalert2";

import InputSelectAsync, { selectStyle } from "../../../../components/InputSelectAsync";
import { BrComerceApiService } from '../../../../services/BrComerceApiService';
import Loading from '../../../home/components/Loading';
import ScrollDiv from "../../components/ScrollDiv";
import styles from "./styles.module.scss";
import DatePicker from "../../../../components/Input/DatePicker";
import moment from "moment";
import { OriginEnum } from "../../../../enums/OriginEnum";
import LoadInfiniteScroll from "../../../../components/LoadInfiniteScroll";
import debounce from "../../../../utils/debounce";
import selectUserImage from "../../../../assets/images/select-user-image.svg";
import { AddCircle, PlusOne } from "@material-ui/icons";

const ManageError = () => {
  const api = new BrComerceApiService();

  const [isLoading, setIsLoading] = useState(false);
  const [loadingResults, setLoadingResults] = useState(false);

  const [filteredErrors, setFilteredErrors] = useState([]);

  const [searchClient, setSearchClient] = useState(null);

  const [integrations, setIntegrations] = useState([]);
  const [selectedIntegration, setSelectedIntegration] = useState({
    value: "",
    label: "Selecione a integração"
  });

  const [orderNumber, setOrderNumber] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [page, setPage] = useState(null);
  const [resultsPerPage, setResultsPerPage] = useState(20);
  const [hasMore, setHasMore] = useState(true);

  const hasUser = !!searchClient?.sub;

  const handleSelectedIntegrationChange = useCallback(e => {
    setSelectedIntegration({
      value: e?.value,
      label: e?.label
    })
  }, []);

  const getAvailablesIntegrations = useCallback(async () => {
    setIsLoading(true);
    try {
      const allIntegrations = Object.values(OriginEnum);

      const parsedIntegrations = [{
        label: "Selecione a integração",
        value: ""
      }];

      for (const integration of allIntegrations) {
        parsedIntegrations.push({
          label: integration.charAt(0).toLocaleUpperCase() + integration.slice(1),
          value: integration
        });
      }

      setIntegrations(parsedIntegrations);
    } catch (err) {
      return Swal.fire({
        title: "Algo deu errado",
        text: "Não foi possível buscar as integrações desse usuário",
        icon: "error"
      });
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleOnChangeCalendarPeriod = e => {
    if (e.dateEnd) {
      const startSplit = e.dateStart.split("/");
      const endSplit = e.dateEnd.split("/");

      const dateStart = new Date(`${startSplit[2]}-${startSplit[1]}-${startSplit[0]} 00:00:00`);
      const dateEnd = new Date(`${endSplit[2]}-${endSplit[1]}-${endSplit[0]} 00:00:00`);

      setStartDate(dateStart);
      setEndDate(dateEnd);
    }
  };

  const handleClearPeriodFilter = () => {
    setStartDate("");
    setEndDate("");
  };

  const getFilteredErrors = useCallback(
    debounce(async () => {
      setLoadingResults(true);
      try {
        const { data, nextPage } = await api.makeHttpRequest({
          method: "GET",
          url: `/shipping-error`,
          params: {
            subUser: searchClient?.sub || " ",
            orderNumber,
            integration: selectedIntegration?.value?.toLocaleLowerCase(),
            startDate,
            endDate,
            perPage: resultsPerPage
          }
        });

        setFilteredErrors(data);
        setLoadingResults(false);

        if (nextPage) {
          setPage(nextPage);
        } else {
          setHasMore(false);
        }
      } catch (err) {
        setLoadingResults(false);
        return Swal.fire({
          title: "Algo deu errado",
          text: "Não foi possível buscar os erros",
          icon: "error"
        })
      }
    }), [
    searchClient,
    selectedIntegration,
    orderNumber,
    startDate,
    endDate,
    page,
    resultsPerPage
  ]);

  const getMoreFilteredErrors = useCallback(
    async () => {
      setLoadingResults(true);
      try {
        const { data, nextPage } = await api.makeHttpRequest({
          method: "GET",
          url: `/shipping-error`,
          params: {
            subUser: searchClient?.sub || " ",
            orderNumber: orderNumber || undefined,
            integration: selectedIntegration?.value?.toLocaleLowerCase() || undefined,
            startDate,
            endDate,
            page,
            resultsPerPage
          }
        });

        setFilteredErrors(previouState => [...previouState, ...data]);
        setLoadingResults(false);

        if (nextPage) {
          setPage(nextPage);
        } else {
          setHasMore(false);
        }

      } catch (err) {
        setLoadingResults(false);
        return Swal.fire({
          title: "Algo deu errado",
          text: "Não foi possível buscar os erros",
          icon: "error",
        })
      }
    }, [
    searchClient,
    selectedIntegration,
    orderNumber,
    startDate,
    endDate,
    page,
    resultsPerPage
  ]);

  useEffect(() => {
    (() => {
      getAvailablesIntegrations();
    })()
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setFilteredErrors([]);
        setHasMore(true);
        if (searchClient && selectedIntegration?.value) {
          getFilteredErrors();
        }
      } catch (e) {
        console.error(e);
      }
    })();
  }, [
    searchClient,
    selectedIntegration,
    orderNumber,
    startDate,
    endDate
  ]);

  return (
    <>
      <Loading isLoading={isLoading} />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.title}>
            <h2>Gerenciar Erros</h2>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.inputWrapper}>
              <div className={styles.selectInput}>
                <InputSelectAsync
                  search={searchClient}
                  setSearch={setSearchClient}
                  placeholder={"Selecione o cliente"}
                />
              </div>
              <div className={styles.selectInput}>
                <Select
                  onChange={e => handleSelectedIntegrationChange(e)}
                  defaultValue={selectedIntegration}
                  value={selectedIntegration}
                  options={integrations}
                  placeholder="Selecione a integração"
                  styles={selectStyle}
                />
              </div>
              <div className={styles.inputOrder}>
                <input
                  onChange={(e) => setOrderNumber(e.target.value)}
                  value={orderNumber}
                  type="number"
                  name="orderNumber"
                  placeholder="Filtre pelo número do pedido"
                />
              </div>
              <div className={styles.inputDateContainer}>
                <DatePicker
                  change={handleOnChangeCalendarPeriod}
                  placeholder="Filtrar por periodo"
                  showClearButton={!!startDate && !!endDate}
                  onClearFields={handleClearPeriodFilter}
                  range
                  className={styles.inputDate}
                />
              </div>
            </div>
          </div>
          <ScrollDiv data={filteredErrors}>
            <InfiniteScroll
              dataLength={filteredErrors.length}
              next={getMoreFilteredErrors}
              hasMore={hasMore}
              scrollableTarget="scrollDiv"
              className={styles.infiniteScroll}
              loader={hasUser && selectedIntegration?.value && loadingResults
                ? (<LoadInfiniteScroll />)
                : hasUser && hasMore && selectedIntegration?.value && filteredErrors?.length ?
                  (
                    <div className={styles.loaderMessage} onClick={() => getMoreFilteredErrors()}>
                      <AddCircle />
                      <span>Carregar mais resultados</span>
                    </div>)
                  : null
              }
            // endMessage={<span className={styles.endMessage}>Não há mais resultados</span>}

            >
              <div className={styles.tableContainer}>
                <table className={styles.table}>
                  <thead className={styles.tableHead}>
                    <tr>
                      <th>
                        Erro
                      </th>
                      <th>
                        Integração
                      </th>
                      <th>
                        Número do pedido
                      </th>
                      <th>
                        Data de entrada
                      </th>
                    </tr>
                  </thead>
                  {hasUser && selectedIntegration?.value && (
                    <tbody className={styles.tableBody}>
                      {(filteredErrors?.length > 0) && filteredErrors.map((e, i) => (
                        <tr key={i}>
                          <td style={{ width: "30%", overflowWrap: "anywhere" }}>
                            {e?.errorMessage}
                          </td>
                          <td>
                            {e?.id.split("-")?.[0]?.charAt(0)?.toUpperCase() + e?.id.split("-")?.[0]?.slice(1)}
                          </td>
                          <td>
                            {e?.orderNumber}
                          </td>
                          <td>
                            {moment(e?.errorDate)?.format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )
                  }
                </table>
                {(!hasUser || !selectedIntegration?.value) && (
                  <div className={styles.selectUserImage}>
                    <img
                      src={selectUserImage}
                      alt="Imagem de uma figura feminina com uma caixa de seleção no fundo"
                    />
                    <h2>
                      Selecione o cliente e integração para visualizar os erros associados aos pedidos
                    </h2>
                  </div>
                )}
              </div>
            </InfiniteScroll>
          </ScrollDiv>
        </div >
      </div >
    </>
  )
}

export { ManageError };

